// 批量导入用户
export const userUrl = '/api/v1/admin/user/upload'


// 批量导入工单
export const orderUrl = '/api/v1/admin/workorder/upload'

// 批量导入门店
export const storeUrl = '/api/v1/admin/store/upload'
